<script>
import NavOnboarding from '@components/accountsManager/nav-onboarding.vue';
import PersonalGoalsDesktop from '@views/accountsManager/desktop/personal-goals-desktop.vue';
import PersonalGoalsMobile from '@views/accountsManager/mobile/personal-goals-mobile.vue';

import { breakpointsMixin } from '@mixins/breakpointsMixin';

export default {
  name: 'PersonalGoals',
  mixins: [breakpointsMixin],
  components: {
    NavOnboarding,
    PersonalGoalsDesktop,
    PersonalGoalsMobile,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<template>
  <div>
    <div class="desktop" v-if="el.is.tabletUp">
      <div class="darken-overlay">
        <NavOnboarding />
        <PersonalGoalsDesktop />
      </div>
    </div>
    <div class="mobile" v-if="!el.is.tabletUp">
      <PersonalGoalsMobile />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

@media only screen and (min-width: 600px) {
  .desktop {
    background: black;
    background: url('../../../assets/images/backgrounds/desktop/onboarding.jpg') center no-repeat;
    background-size: cover;
    display: block;
    height: 100%;
    min-height: 900px;
    opacity: 0.98;
    position: absolute;
    width: 100%;

    .darken-overlay {
      background-color: rgba(0, 0, 0, 0.45);
      display: block;
      height: 100%;
      position: absolute;
      width: 100%;
    }
  }

  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: flex;
    height: 100%;
    position: absolute;
    width: 100%;
  }
}
</style>
